import { localEditorShowReplaceAvatarHint } from "../../State";

export const setShowReplaceAvatarHint = (showReplaceHint: boolean) => {
    localEditorShowReplaceAvatarHint(showReplaceHint);
};
